<nav class="nav flex-column sidebar d-flex justify-content-between" [ngClass]="
    !isMediumScreen || toggleSidebar ? 'show-side-bar' : 'hide-side-bar'
  ">
  <div>
    <div class="d-sm-block d-md-none icon-sidebar mb-1" [ngClass]="toggleSidebar ? 'text-start' : 'text-center'"
      [class.flipped]="toggleSidebar">
      <i class="bi bi-chevron-double-right fs-5" style="color: #8f90a6" (click)="onToggleSidebar()"></i>
    </div>
    <div *ngFor="let menu of menus" class="menu-item no-select">
      <a *ngIf="menu.link" class="nav-link main-link d-flex align-items-center justify-content-between"
        routerLink="{{ menu.link }}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <span class="d-flex" style="gap: 8px; align-items: end">
          <img class="object-fit-cover img-active" src="assets/icons/{{ menu.iconImg }}.png" alt="{{ menu.iconImg }}"
            width="24" height="24" (click)="updateSingleMenu()" />
          <span [ngClass]="!isMediumScreen || toggleSidebar ? 'd-block' : 'd-none'">
            {{ menu.title }}
          </span>
        </span>
        <span class="badge align-self-center"
          *ngIf="menu.menu_code === 'm_request' && (menu.notification_count && menu.notification_count > 0)">{{menu.notification_count}}</span>

      </a>
      <a *ngIf="!menu.link" class="nav-link d-flex align-items-center justify-content-between"
        (click)="toggleMenu(menu)">
        <span class="d-flex" style="gap: 8px; align-items: end">
          <img class="object-fit-cover img-active" src="assets/icons/{{ menu.iconImg }}.png" alt="{{ menu.iconImg }}"
            width="24" height="24" />
          <span class="d-inline-flex align-items-center"
            [ngClass]="!isMediumScreen || toggleSidebar ? 'd-block' : 'd-none'">
            {{ menu.title }}
          </span>
        </span>
        <span class="badge ms-1"
          *ngIf="menu.menu_code === 'm_request' && (menu.notification_count && menu.notification_count > 0)">{{menu.notification_count}}</span>

        <img *ngIf="menu.mainMenus.length" class="object-fit-cover"
          [ngClass]="!isMediumScreen || toggleSidebar ? 'd-block' : 'd-none'" [class.rotate]="menu.expanded"
          src="assets/icons/angle-down.png" alt="angle" width="24" height="24" />
      </a>
      <div *ngIf="menu.expanded && (!isMediumScreen || toggleSidebar)" class="sub-menu">
        <span [ngClass]="{ 'sub-line': menu.expanded }"></span>
        <div *ngFor="let mainMenu of menu.mainMenus">
          <a *ngIf="mainMenu.link" class="nav-link sub-nav-link d-flex align-items-center justify-content-between"
            routerLink="{{ mainMenu.link }}" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
            <span class="d-inline-flex align-items-end">{{ mainMenu.title }}
            </span>

            <span class="badge ms-1 align-items-center"
              *ngIf="mainMenu.notification_count && mainMenu.notification_count > 0">{{mainMenu.notification_count}}</span>

          </a>

          <!-- subMenu inside main menus -->
          <div *ngIf="mainMenu.subMenus?.length"
            class="nav-link sub-nav-link nested-link d-flex align-items-center justify-content-between"
            (click)="toggleMenu(mainMenu)">
            <span class="d-inline-flex align-items-end">{{ mainMenu.title }}
            </span>

            <span class="badge ms-1 align-items-center"
              *ngIf="mainMenu.notification_count && mainMenu.notification_count > 0">{{mainMenu.notification_count}}</span>

            <img *ngIf="mainMenu.subMenus?.length" class="object-fit-cover" [ngClass]="
                !isMediumScreen || toggleSidebar ? 'd-block' : 'd-none'
              " [class.rotate]="mainMenu.expanded" src="assets/icons/angle-down.png" alt="angle" width="24"
              height="24" />
          </div>

          <div *ngIf="
              mainMenu.subMenus?.length &&
              mainMenu.expanded &&
              (!isMediumScreen || toggleSidebar)
            " class="sub-menu">
            <a *ngFor="let subMenu of mainMenu.subMenus"
              class="nav-link sub-nav-link nested-nav-link align-items-center justify-content-between"
              [routerLink]="subMenu.link" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
              <li>
                <div class="d-flex align-items-center justify-content-between">

                  <span class="d-inline-flex align-items-end">{{ subMenu.title }}
                  </span>

                  <span class="badge ms-1 align-items-center"
                    *ngIf="subMenu.notification_count && subMenu.notification_count > 0">{{subMenu.notification_count}}</span>

                </div>

              </li>

            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sidebar-footer text-end" [ngbTooltip]="apiVersionText" [disableTooltip]="!apiVersionText"
    placement="right">
    <small>Version: {{ appVersion.version }}</small><br />
    <div *ngIf="apiVersionResponse">
      <small>Api Version: {{ apiVersionResponse.version }}</small><br />
    </div>
  </div>
</nav>